import { render } from "./BoardPriceCalculator.vue?vue&type=template&id=564a6dc5&scoped=true"
import script from "./BoardPriceCalculator.vue?vue&type=script&lang=js"
export * from "./BoardPriceCalculator.vue?vue&type=script&lang=js"

import "./BoardPriceCalculator.vue?vue&type=style&index=0&id=564a6dc5&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-564a6dc5"]])

export default __exports__